import React, { Component } from "react";
import AMapLoader from "@amap/amap-jsapi-loader";

class MapComponent extends Component {
    constructor() {
        super();
        this.map = {};
    }
    // 2.dom渲染成功后进行map对象的创建
    componentDidMount() {
        AMapLoader.load({
            key: "1fb089d0886370d069de60b28db8d101", // 申请好的Web端开发者Key，首次调用 load 时必填
            version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
            plugins: ["AMap.Walking"], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
        })
            .then((AMap) => {
                this.AMap = AMap;
                this.map = new AMap.Map("container", {
                    //设置地图容器id
                    zoom: 5, //初始化地图级别
                    center: [105.602725, 37.076636], //初始化地图中心点位置
                });

                var walkingOption = {};

                // 步行导航
                var walking = new AMap.Walking(walkingOption);
                const that = this;
                //根据起终点坐标规划步行路线
                walking.search(
                    [116.399028, 39.845042],
                    [116.436281, 39.880719],
                    function (status, result) {
                        // result即是对应的步行路线数据信息，相关数据结构文档请参考  https://lbs.amap.com/api/javascript-api/reference/route-search#m_WalkingResult
                        if (status === "complete") {
                            if (result.routes && result.routes.length) {
                                that.drawRoute(result.routes[0]);
                                console.log("绘制步行路线完成");
                            }
                        } else {
                            console.log(result);
                        }
                    }
                );
            })
            .catch((e) => {
                console.log(e);
            });
    }

    drawRoute(route) {
        var path = this.parseRouteToPath(route);
        let map = this.map;
        var startMarker = new this.AMap.Marker({
            position: path[0],
            icon: "https://webapi.amap.com/theme/v1.3/markers/n/start.png",
            map: map,
            anchor: "bottom-center",
        });
        var endMarker = new this.AMap.Marker({
            position: path[path.length - 1],
            icon: "https://webapi.amap.com/theme/v1.3/markers/n/end.png",
            map: map,
            anchor: "bottom-center",
        });
        var routeLine = new this.AMap.Polyline({
            path: path,
            isOutline: true,
            outlineColor: "#ffeeee",
            borderWeight: 2,
            strokeWeight: 5,
            strokeColor: "#0091ff",
            strokeOpacity: 0.9,
            lineJoin: "round",
        });

        this.map.add(routeLine);

        // 调整视野达到最佳显示区域
        this.map.setFitView([startMarker, endMarker, routeLine]);
    }
    parseRouteToPath(route) {
        var path = [];
        for (var i = 0, l = route.steps.length; i < l; i++) {
            var step = route.steps[i];
            for (var j = 0, n = step.path.length; j < n; j++) {
                path.push(step.path[j]);
            }
        }
        return path;
    }

    render() {
        // 1.初始化创建地图容器,div标签作为地图容器，同时为该div指定id属性；
        return (
            <div
                id="container"
                className="map"
                style={{ width: "100%", height: "100vh" }}
            ></div>
        );
    }
}
//导出地图组建类
export default MapComponent;



// WEBPACK FOOTER //
// ./src/marketingOnline/map/index.js